"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsStatus = void 0;
var AnalyticsStatus;
(function (AnalyticsStatus) {
    AnalyticsStatus["Pending"] = "pending";
    AnalyticsStatus["Critical"] = "critical";
    AnalyticsStatus["NeedsLabeling"] = "needs_labeling";
    AnalyticsStatus["AnalyticsRegression"] = "regression";
    AnalyticsStatus["AnalyticsStale"] = "analytics_stale";
    AnalyticsStatus["DataStale"] = "data_stale";
    AnalyticsStatus["Healthy"] = "healthy";
    AnalyticsStatus["None"] = "none";
    AnalyticsStatus["Locked"] = "locked";
    AnalyticsStatus["Recovering"] = "recovering";
    AnalyticsStatus["Unknown"] = "unknown";
})(AnalyticsStatus = exports.AnalyticsStatus || (exports.AnalyticsStatus = {}));
//# sourceMappingURL=Analytics.js.map